import { render, staticRenderFns } from "./newclaim.vue?vue&type=template&id=072f7be9&"
import script from "./newclaim.vue?vue&type=script&lang=js&"
export * from "./newclaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports